import {
  CarPortfolioHeatmapChartItem,
  CarPortfolioHeatmapChartDataset,
} from "../assetAllocation/asset-allocation-types";

export const useSimulatedForwardProbabilitiesACData = ({
  nominalHeatmap1,
  realHeatmap1,
  simulationSuffix1,
  nominalHeatmap2,
  realHeatmap2,
  simulationSuffix2,
  isAdvanced,
  isReal,
  chartDateRange1,
  chartDateRange2,
}: {
  nominalHeatmap1: CarPortfolioHeatmapChartItem[];
  realHeatmap1: CarPortfolioHeatmapChartItem[];
  simulationSuffix1: string;
  nominalHeatmap2: CarPortfolioHeatmapChartItem[];
  realHeatmap2: CarPortfolioHeatmapChartItem[];
  simulationSuffix2: string;

  isAdvanced: boolean;
  isReal: boolean;
  chartDateRange1: number;
  chartDateRange2: number;
}) => {
  const realLabel = isReal ? "Real" : "Nominal";

  const selectedHeatmap1 = isReal ? realHeatmap1 : nominalHeatmap1;
  const selectedHeatmap2 = isReal ? realHeatmap2 : nominalHeatmap2;

  const getChartData = ({
    data1Id,
    data2Id,
  }: {
    data1Id?: string;
    data2Id?: string;
  }) => {
    const selectedItem1 = selectedHeatmap1.find((i) => i.id === data1Id);
    const selectedItem2 = selectedHeatmap2.find(
      (i) => i.id === (isAdvanced ? data2Id : data1Id),
    );

    const secondaryDateRange = isAdvanced ? chartDateRange2 : chartDateRange1;
    const secondarySuffix = isAdvanced ? simulationSuffix1 : simulationSuffix2;

    const selectedItem1Datasets =
      selectedItem1?.datasets.map<CarPortfolioHeatmapChartDataset>((ds) => ({
        ...ds,
        x: ds.x.slice(0, chartDateRange1 + 1),
        y: ds.y.slice(0, chartDateRange1 + 1),
      })) ?? [];

    const selectedItem2Datasets =
      selectedItem2?.datasets.map<CarPortfolioHeatmapChartDataset>((ds) => ({
        ...ds,
        x: ds.x.slice(0, secondaryDateRange + 1),
        y: ds.y.slice(0, secondaryDateRange + 1),
      })) ?? [];

    return {
      selectedHeatmap1,
      label1: `${simulationSuffix1}: ${selectedItem1?.fullLabel} Simulated Outcome (${realLabel})`,
      label1Downside: `${simulationSuffix1}: ${selectedItem1?.fullLabel} Simulated Downside (${realLabel})`,
      datasets1: selectedItem1Datasets,

      label2: `${secondarySuffix}: ${selectedItem2?.fullLabel} Simulated Outcome (${realLabel})`,
      label2Downside: `${secondarySuffix}: ${selectedItem2?.fullLabel} Simulated Downside (${realLabel})`,
      datasets2: selectedItem2Datasets,
    };
  };

  return {
    getChartData,
  };
};

export type SimulatedForwardProbabilitiesACData = ReturnType<
  ReturnType<typeof useSimulatedForwardProbabilitiesACData>["getChartData"]
>;
